export default {
  data () {
    return {
      cdParameters: {
        title: '',
        text: '',
        buttonPosition: 'right',
        width: 330,
      },
    }
  },

  methods: {

    cdMessageResponse (cdResponse) {
      if (cdResponse === false) {
        // [24/01/25] console.log('::: cdMessageResponse:', 'cancelado')
        return false
      } else {
        // [24/01/25] console.log('::: cdMessageResponse:', cdResponse)
      }
    },

    /**
     *
     * DIALOG
     * 1) AÇÃO => this.showDialog('Atenção!', 'aaa', 'edit-week', week)
     * 2) SEM AÇÃO => this.showDialog('Atenção!', 'aaa', 'edit-week', week, false)
     *
     */

    showConfirmBox: function (args = {}) {
      this.cdParameters.title = args.title
      this.cdParameters.text = args.text
      this.cdParameters.buttonPosition = args.buttonPosition
      this.cdParameters.width = args.width

      const cb = args?.checkbox === true ? { cdCheckbox: true, cdCheckboxLabel: args.checkboxLabel || "Estou ciente" } : {}

      /* args.title
      args.text
      args.type
      args.data
      args.isResponse = false
      args.buttonPosition = 'right'
      args.width = 330 */

      if (args.isResponse) {
        this.$refs.cdConfirmModal.open({ cdType: args.type, cdData: args.data, ...cb, args }, false)
      } else {
        this.$refs.cdConfirmModal.open({ cdType: args.type, cdData: args.data, ...cb, args })
      }
    },

    showDialog: function (title, text, type, data, isResponse = false, buttonPosition = 'right', width = 330, closeWithAction = false) {
      this.cdParameters.title = title
      this.cdParameters.text = text
      this.cdParameters.buttonPosition = buttonPosition
      this.cdParameters.width = width

      if (isResponse) {
        this.$refs.cdConfirmModal.open({ cdType: type, cdData: data }, false, closeWithAction)
      } else {
        // this.$refs.cdConfirmModal.open({ cdType: type, cdData: data })
        this.$refs.cdConfirmModal.open({ cdType: type, cdData: data }, true, closeWithAction)
      }
    },

    showDialogWithPassword: function (title, text, cdType, cdData, isResponse = false, buttonPosition = 'right', width = 330, closeWithAction = false, cdPassword = '', callback = () => {}) {
      this.cdParameters.title = title
      this.cdParameters.text = text
      this.cdParameters.buttonPosition = buttonPosition
      this.cdParameters.width = width

      this.$refs.cdConfirmModal.open({ cdType, cdData, cdPassword, callback }, !!isResponse === false, closeWithAction)

      // this.$refs.cdConfirmModal.open({ cdType, cdData, cdPassword }, !!isResponse === true ? false : true, closeWithAction)
    },

    showMessage: function (title, text, buttonPosition = 'right', width = 330) {
      this.cdParameters.title = title
      this.cdParameters.text = text
      this.cdParameters.buttonPosition = buttonPosition
      this.cdParameters.width = width

      // cd Message Modal
      this.$refs.cdConfirmModal.open({ cdType: 'message', cdData: { title, text } }, false)
    },
  },
}
